import { Divider } from "antd";
import { styled } from "styled-components";

export const StyledVerticalNav = styled.div`
  .ant-menu {
    border-inline-end: none !important;
    padding: 0px;
    .ant-menu-item {
      padding: 8px !important;
      margin: 0px !important;
      width: 100% !important;
      &.ant-menu-item-only-child {
        &.ant-menu-item-selected {
          padding-left: 12px !important;
        }
      }
    }
  }
  .ant-menu-submenu {
    .ant-menu-submenu-title {
      padding-left: 0px !important;
    }
  }
  .ant-menu-sub {
    background: none !important;
    .ant-menu-item {
      padding: 8px 8px 8px 24px !important;
    }
  }
  padding-bottom: 16px;
`;

export const StyledVerticalNavDivider = styled(Divider)`
  margin: 16px 0px;
  border-block-start-color: ${({ theme }) => theme.palette.borderColor.default};
`;
